<template>
    <div class="m-offer shop-discount shop-view">
        <div class="shop-banner" :class="'banner-' +  sid "></div>
        <div class="m-ticket">
            <div class="ticket-header"></div>
            <div class="ticket-view">
                <div class="ticket-wrapper">
                    <ul v-if="shop_list.length > 0">
                        <li v-for="(item,index) in shop_list" :key="index">
                            <div class="status apply" v-if="item.state == 1"></div>
                            <div class="status dismiss" v-if="item.state == 2"></div>
                            <div class="ticket">
                                <p>店铺专用券</p>
                            </div>
                            <div class="ticket-detail">
                                <h6>{{ item.shopName }}</h6>
                                <p>{{ item.shopOfferName }}</p>
                                <p class="time">{{ time }}</p>
                            </div>
                        </li>
                    </ul>

                    <div class="notice" v-else>
                        <p>一张优惠券也没有~</p>
                    </div>
                </div>
            </div>
            <div class="ticket-footer"></div>
        </div>

        <div class="shop-goods-list shop-panel">
            <div class="goods-list">
                <vuescroll>
                <ul>
                    <li v-for="(item,index) in goodslist" :key="index">
                        <div class="goods-panel">
                            <div class="goods-detail">
                                <div class="goods-status">
                                    <div class="tag tag-sale" v-if="item.discountType"></div>
                                    <div class="tag tag-shop" v-if="item.shopOfferType"></div>
                                </div>
                            <h6 class="item-name">{{ item.name }} * {{ item.itemcount }}</h6>
                            <div class="discount">{{ item.discountName }}</div>
                            <div class="pic" v-if="$store.state.tipsimg.indexOf(item.itemid) > -1" 
                                @click="$item_tips({ item_id : item.itemid + '.png',type : 'img'})">
                                <div class="item-pic"><game-item :id="item.itemid" :num="item.itemcount" :locked="true"></game-item></div>
                                <!-- <img v-bind:src="item.img" v-bind:alt="item.name"> -->
                            </div>
                            <div class="pic" v-else @click="$item_tips({ item_id : item.itemid })" >
                                <div class="item-pic"><game-item :id="item.itemid" :num="item.itemcount" :locked="true"></game-item></div>
                                <!-- <img v-bind:src="item.img" v-bind:alt="item.name"> -->
                            </div>
                            <div class="low">最低价<em class="icon-m3b"></em><span>{{ item.priceMin }}</span><span class="p-before">{{ item.priceBefore }}</span></div>
                                <div class="banner" v-bind:data-sid="item.shopId" @click="sid = item.shopId;">{{ item.shopName }}</div>
                            </div>
                        </div>

                        <div class="u-btn apply" v-bind:data-gid="item.id" @click="$share_modal({gid : item.id});"></div>
                    </li>
                </ul>
                </vuescroll>
            </div>                        
        </div>

        <recommend></recommend>

        <div class="bottom-bubble">
            <div class="txt-bubble"></div>
            <div class="u-btn u-top"></div>
        </div>          
    </div>
</template>

<script>
import vuescroll from 'vuescroll';
import recommend from '@/components/recommend.vue';

export default {
    data (){
        return {
            sid : 0,
            shop_list : [],
            time : this.$global.activityTime,
            goodslist : [],
        }
    },
    components : {
        vuescroll,
        'recommend' : recommend,
    },
    watch : {
        sid(newVal){
            this.shop_list = this.shop_offer.filter(function(e){
                return e.shopId == newVal;
            });
        },
    },      
    created (){
        var _this = this;
        this.sid = this.$route.params.sid || 0;
        this.shop_list = this.shop_offer.filter(function(e){
            return e.shopId == _this.sid;
        });

        this.goods_list_render();
    },
    props : {
        shop_offer :{
            default : [],
        },
    },
    methods : {
        goods_list_render (){
            var _this = this;
            this.$axios.get(this.$ajax_url_map.goodslist)
            .then(res => {
                this.$goodslist_update(res.data.list)
                if(!res.data.list.length)return;
                this.goodslist = res.data.list.filter(function(e){
                    return e.shopId == _this.sid
                });
            },
            rej => {
                console.log(rej)
            })            
        },
    },     
}
</script>

<style scoped>
/* ticket */
.shop-discount {
    position: absolute;
    left: 0;
    top: 0;
    width: 750px;
    min-height: 100vh;
    padding-top: 10px;
    background-image: url(~@/assets/images/body-basket.jpg);
    background-size: 750px auto;
    background-repeat: repeat-y;
    overflow-y: scroll;
}

.shop-discount .shop-banner {
    width: 750px;
    height: 535px;
    margin: 0 auto;
}

.shop-discount .banner-11 {
    background-image: url(~@/assets/images/banner/11.png);
}

.shop-discount .banner-12 {
    background-image: url(~@/assets/images/banner/12.png);
}

.shop-discount .banner-13 {
    background-image: url(~@/assets/images/banner/13.png);
}

.shop-discount .banner-0,
.shop-discount .banner-21 {
    background-image: url(~@/assets/images/banner/21.png);
}

.ticket-header {
    position: relative;
    width: 750px;
    height: 43px;
    margin: 0 auto 0;
    background-image: url(~@/assets/images/bg-ticket-top.png);
    pointer-events: none;
}

.m-ticket {
    margin: 20px auto;
}

.ticket-view {
    min-height: 162px;
    margin-top: -1px;
    background: url(~@/assets/images/bg-ticket-body.png) center top repeat-y;
    background-size: 750px auto;
}

.ticket-view .notice{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 162px;
}

.notice p{
    font-size: 40px;
    color: #ad7239;
}

.ticket-footer {
    width: 750px;
    height: 41px;
    margin: -10px auto 20px;
    background-image: url(~@/assets/images/bg-ticket-bottom.png);
}

.ticket-view li {
    display: flex;
    width: 672px;
    height: 162px;
    margin: 0 auto 10px;
    align-items: center;
    background-image: url(~@/assets/images/item-ticket.png);
}

.ticket-view .status {
    margin-left: 20px;
}

.ticket-view .status.apply {
    width: 49px;
    height: 49px;
    background-image: url(~@/assets/images/ticke-apply.png);
}

.ticket-view .status.dismiss {
    width: 73px;
    height: 89px;
    background-image: url(~@/assets/images/ticket-dismiss.png);
}

.ticket-view .ticket {
    position: relative;
    width: 211px;
    height: 124px;
    margin: 0 20px;
    background-image: url(~@/assets/images/sale-8.png);
}

.ticket-view .ticket p {
    position: absolute;
    left: 0;
    bottom: 10px;
    padding-left: 55px;
}

.ticket-view .ticket-detail {
    color: #6a2b0f;
}

.ticket-view .ticket-detail h6 {
    font-weight: 700;
    font-size: 28px;
}

.ticket-view .ticket-detail .time {
    color: #b4603b;
}

.shop-goods-list {
    width: 750px;
    height: 1344px;
    margin-top: -100px;
    padding-top: 200px;
    background-image: url(~@/assets/images/bg-shop-pannel.png);
    box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/views/offer.vue